import {
  decryptInfoShareAttachmentFile,
  decryptInfoShareAttachmentName,
  type InfoShareAttachment,
} from '../crypto/infoShareAttachments';
import { triggerBrowserDownload } from '../crypto/sharedFolderFile';
import { inferContentTypeFromFileName, fileTypeIconFor } from '../files/fileTypes';
import { applyI18n, t } from '../i18n';
import { fileTypeImg } from './fileTypeImg';
import { api } from '../api/client';

export async function renderGuestInfoShareAttachments(options: {
  container: HTMLElement;
  attachments: InfoShareAttachment[];
  contentKey: Uint8Array;
  token: string;
  multiUseAccess: boolean;
  onError: (messageKey: string) => void;
}): Promise<void> {
  const { container, attachments, contentKey, token, multiUseAccess, onError } = options;
  container.replaceChildren();
  if (attachments.length === 0) {
    container.hidden = true;
    return;
  }

  container.hidden = false;
  const heading = document.createElement('h3');
  heading.dataset.i18n = 'info.guest.attachmentsTitle';
  container.append(heading);

  if (!multiUseAccess) {
    const purgeNote = document.createElement('p');
    purgeNote.className = 'muted';
    purgeNote.dataset.i18n = 'info.guest.attachmentPurgeHint';
    container.append(purgeNote);
  }

  const list = document.createElement('ul');
  list.className = 'guest-message-attachments';
  container.append(list);
  applyI18n(container);

  for (const attachment of attachments) {
    const item = document.createElement('li');
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'button ghost';
    let attachmentFileName = '';
    try {
      attachmentFileName = await decryptInfoShareAttachmentName(contentKey, attachment.encryptedName);
      const icon = fileTypeImg(fileTypeIconFor(
        attachmentFileName,
        inferContentTypeFromFileName(attachmentFileName),
      ), 16);
      button.append(icon, document.createTextNode(attachmentFileName));
    } catch {
      button.textContent = t('info.guest.attachment');
    }

    button.addEventListener('click', () => {
      void (async () => {
        if (!attachmentFileName) {
          onError('info.guest.attachmentFailed');
          return;
        }
        try {
          const bytes = await decryptInfoShareAttachmentFile(contentKey, attachment);
          triggerBrowserDownload(attachmentFileName, bytes);
          if (!multiUseAccess) {
            try {
              await api.completeInfoShareAttachmentDownload(token, attachment.blobId);
            } catch (cause) {
              console.warn('Download-complete handshake failed', cause);
            }
            const done = document.createElement('p');
            done.className = 'muted';
            done.dataset.i18n = 'info.guest.attachmentPurged';
            applyI18n(done);
            item.append(done);
            button.disabled = true;
          }
        } catch (cause) {
          console.error('Guest attachment download failed', cause);
          onError('info.guest.attachmentFailed');
        }
      })();
    });

    item.append(button);
    list.append(item);
  }
}
